export default __webpack_public_path__ + "static/media/Lotte.278dfe28.png";